import { motion } from "framer-motion";
import { WHY_US } from "../../data/site";

export default function WhyAppFillip() {
  return (
    <section
      id="why"
      className="py-20 md:py-28 bg-zinc-50 border-y border-zinc-200"
      data-testid="why-section"
    >
      <div className="container">
        <div className="max-w-3xl mb-14">
          <p className="text-overline text-electric mb-3">02 — Why AppFillip</p>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold text-charcoal text-balance">
            Why 100+ Apps Trust AppFillip for ASO & App Growth
          </h2>
          <p className="mt-5 text-lg text-zinc-600">
            We're not a generic mobile app marketing agency. We're a global app
            growth lab — combining engineering, optimization and storytelling
            into one operating system for app ranking, across every major app
            store and market.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-zinc-200">
          {WHY_US.map((w, idx) => {
            const Icon = w.icon;
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.04 }}
                className="group p-7 md:p-9 border-r border-b border-zinc-200 bg-white hover:bg-charcoal hover:text-white transition-colors"
                data-testid={`why-card-${idx}`}
              >
                <div className="flex items-center gap-3 mb-5">
                  <span className="w-9 h-9 grid place-items-center bg-electric text-white">
                    <Icon className="w-4 h-4" strokeWidth={2.5} />
                  </span>
                  <span className="text-overline text-zinc-500 group-hover:text-zinc-300">
                    0{idx + 1}
                  </span>
                </div>
                <h3 className="font-display text-xl md:text-2xl font-bold leading-tight">
                  {w.title}
                </h3>
                <p className="mt-3 text-[15px] text-zinc-600 group-hover:text-zinc-300 leading-relaxed">
                  {w.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
